<template>
  <section class="[ !p-0 ]">
    <router-view />
  </section>
</template>

<script setup lang="ts">
definePage({
  meta: {
    icon: "calls",
    title: "Calls",
  },
  redirect: "/calls/live-call",
});
</script>
